import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-assign-role',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './assign-role.component.html',
  styleUrls: ['./assign-role.component.css']
})
export class AssignRoleComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  password = signal('');
  isLoading = signal(false);
  errorMessage = signal<string | null>(null);
  showPassword = signal(false);

  togglePasswordVisibility(): void {
    this.showPassword.update(v => !v);
  }

  onSubmit(): void {
    if (!this.password()) {
      this.errorMessage.set('Пожалуйста, введите пароль');
      return;
    }

    this.isLoading.set(true);
    this.errorMessage.set(null);

    this.authService.assignRole(this.password()).subscribe({
      next: () => {
        this.isLoading.set(false);
        this.router.navigate(['/']);
      },
      error: (err) => {
        this.isLoading.set(false);
        const body = err?.error;
        if (body?.res?.ru) {
          this.errorMessage.set(body.res.ru);
        } else if (body?.msg) {
          this.errorMessage.set(body.msg);
        } else {
          this.errorMessage.set('Не удалось получить роль');
        }
      }
    });
  }

  onLogout(): void {
    this.authService.logout();
  }
}
